import { bookingThemeStyle, deriveBookingTheme } from '@shared/core/booking-branding'
import { useMemo } from 'react'
import type { CSSProperties } from 'react'
import { useProviderDetails } from 'src/modules/booking/hooks'
import { Loader } from 'src/modules/core/components/loader'
import type { BookingThemedRootProps } from './booking-themed-root.interface'
import classes from './booking-themed-root.module.scss'

const HIDDEN_STYLE: CSSProperties = { visibility: 'hidden' }

// The tree keeps one shape in both states so the children never remount on reveal.
export function BookingThemedRoot({ providerId, className, children }: BookingThemedRootProps) {
  const { data, isError } = useProviderDetails(providerId ?? '', { enabled: !!providerId })
  const accentColor = data?.accent_color ?? null
  const themeStyle = useMemo(() => bookingThemeStyle(deriveBookingTheme(accentColor)), [accentColor])
  const isReady = !!data || isError

  return (
    <div
      className={isReady ? className : classes.neutralFrame}
      style={isReady ? (themeStyle as CSSProperties) : undefined}
      aria-busy={isReady ? undefined : true}
    >
      {!isReady && <Loader isLoading={true} full />}
      <div
        className={isReady ? classes.content : classes.hiddenContent}
        style={isReady ? undefined : HIDDEN_STYLE}
        aria-hidden={isReady ? undefined : true}
      >
        {children}
      </div>
    </div>
  )
}
